
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post-listing",
      function () {
        return require("private-next-pages/post-listing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post-listing"])
      });
    }
  